import { Component, EventEmitter, Output, ViewEncapsulation } from '@angular/core';
import {MatDialog, MatDialogRef} from "@angular/material";
import {
  FormVariables
} from '../../../../../../../../sellions_forms/projects/forms/src/lib/interfaces/form-variables.interface';

@Component({
  selector: 'close-dialog',
  templateUrl: './close-dialog.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class CloseDialogComponent {
  @Output() onDialogClose: EventEmitter<Boolean> = new EventEmitter<Boolean>();

  constructor(private dialog: MatDialog) {
  }

  close():void {
    this.onDialogClose.emit(true);
    this.dialog.closeAll();
  }
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/components/form-viewer/close-dialog/close-dialog.component.ts